import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers = {'Accept': 'application/json', 'Content-Type': 'application/json'}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  created () {   
    const user = localStorage.getItem('User')
    if(user) {
      this.$store.commit('setUser', JSON.parse(user))
    }
    axios.interceptors.response.use(
      response =>{        
          return response
        },
      error => {       
        if(error.response.status === 401) {
          this.$store.dispatch('deleteUser')
          router.go({path: '/login'})
        }        
        return Promise.reject(error)
      }
    )
  },
  render: h => h(App)
}).$mount('#app')
